module.exports = __webpack_public_path__ + "img/kleisma4-m@1.0a1bf2b7.jpg";